import { render, staticRenderFns } from "./progressParts-setting.vue?vue&type=template&id=84a2305e&scoped=true"
import script from "./progressParts-setting.vue?vue&type=script&lang=js"
export * from "./progressParts-setting.vue?vue&type=script&lang=js"
import style0 from "./progressParts-setting.vue?vue&type=style&index=0&id=84a2305e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a2305e",
  null
  
)

export default component.exports